import { DOCUMENT_STATUS_LABELS, type DocumentStatus } from "@ckgo2/shared/types";
import { FileText, Send, Eye, CheckCircle2, Ban } from "lucide-react";

const CONFIG: Record<DocumentStatus, { cls: string; Icon: typeof FileText }> = {
  draft: { cls: "bg-gray-100 text-gray-600", Icon: FileText },
  sent: { cls: "bg-blue-100 text-blue-700", Icon: Send },
  viewed: { cls: "bg-amber-100 text-amber-700", Icon: Eye },
  signed: { cls: "bg-emerald-100 text-emerald-700", Icon: CheckCircle2 },
  void: { cls: "bg-gray-100 text-gray-400 line-through", Icon: Ban },
};

/** Document signing-lifecycle badge (draft → sent → viewed → signed; void). */
export default function SignStatusBadge({ status }: { status: DocumentStatus }) {
  const { cls, Icon } = CONFIG[status] ?? CONFIG.draft;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium ${cls}`}
    >
      <Icon className="h-3 w-3" />
      {DOCUMENT_STATUS_LABELS[status] ?? status}
    </span>
  );
}
